module.exports = __webpack_public_path__ + "img/img_app@2x.ff56a7d8.png";